export default "__VITE_ASSET__BSBUIJNW__"